// src/hooks/cities/useUpdateCity.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateCity } from "../../api/apiCities";
import parseError from "../../utils/parseError";

const useUpdateCity = () => {
    const queryClient = useQueryClient();

    const { mutate: updateCityMutate, isPending } = useMutation({
        mutationFn: ({ id, req }) => updateCity(req, id),
        onSuccess: (res) => {
            const message = res?.message || "City updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["cities"] });
            queryClient.invalidateQueries({ queryKey: ["city"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update city");
        },
    });

    return { updateCityMutate, isPending };
};

export default useUpdateCity;